import React from 'react';
import PlanningFunctional from './components/planning-functional';
import './planning.scss';

const Planning = () => {
	return <PlanningFunctional />;
};

export default Planning;
